import { FilePresentRounded } from "@mui/icons-material";
import { Avatar, Box } from "@mui/material";

import { useUserStore } from "@store/userStore";

import theme from "@theme/index";

interface IUserChatBubbleProperties {
  isFile?: boolean;
  message: string;
}

const getFirstLetter = (firstName: null | string | undefined, lastName: null | string | undefined) => {
  if (!firstName && !lastName) {
    return "U";
  }
  return `${firstName?.[0]}${lastName?.[0]}`;
};

const UserChatBubble = ({ isFile = false, message }: IUserChatBubbleProperties) => {
  const { firstName, lastName } = useUserStore();

  return (
    <Box
      sx={{
        "& h4": {
          margin: 0,
          marginTop: 2,
        },
        "& p": {
          margin: 0,
        },
        "& ul": {
          marginTop: 1,
        },
        display: "flex",
        gap: 1,
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          backgroundColor: "#E8F5E9",
          borderRadius: "8px",
          display: "flex",
          px: 2,
          py: 2,
        }}
      >
        {isFile && <FilePresentRounded sx={{ mr: 1 }} />}
        {message}
      </Box>
      <Box>
        <Avatar sx={{ backgroundColor: theme.palette.secondary.main, fontSize: "1rem" }}>
          {getFirstLetter(firstName, lastName)}
        </Avatar>
      </Box>
    </Box>
  );
};

export default UserChatBubble;
